export default "__VITE_ASSET__3daa289a__"